/*
 *  Developed by CQ Inversiones SAS. Copyright (c) 2024. All rights reserved.
 *  Desarrollado por CQ Inversiones SAS. Copyright (c) 2024. Todos los derechos reservados.
 */

import {TableColumnAlignEnum, TableColumnEnum, TableColumnInterface, TableIconEnum} from '@shared/components/table';

/**
 * @description
 * Header array for commands table
 */
export const COMMANDS_MAIN_HEADERS: TableColumnInterface[] = [
  {
    field: 'name',
    type: TableColumnEnum.text,
    header: 'app.setting.commands.fields.name.label',
    align: TableColumnAlignEnum.center,
  },
  {
    field: 'os_command',
    type: TableColumnEnum.icon,
    header: 'app.setting.commands.fields.osCommand.label',
    align: TableColumnAlignEnum.center,
    dualIcon: [TableIconEnum.file, TableIconEnum.fileSlash],
  },
  {
    field: 'show',
    type: TableColumnEnum.iconDual,
    header: 'app.setting.commands.fields.show.label',
    align: TableColumnAlignEnum.center,
    dualIcon: [TableIconEnum.circleCheck, TableIconEnum.circleClose]
  },
  {
    field: 'staff',
    type: TableColumnEnum.iconDual,
    header: 'app.setting.commands.fields.staff.label',
    align: TableColumnAlignEnum.center,
    dualIcon: [TableIconEnum.circleCheck, TableIconEnum.circleClose]
  },
  {
    field: 'enabled',
    type: TableColumnEnum.tag,
    header: 'app.setting.commands.fields.status',
    align: TableColumnAlignEnum.center,
  },
]
